import type {Tree, TreeLeaf} from '../../types';

// All we need here is just to pass around a reference to a number, so
// we don't need a whole class for this, could be a simple
// struct (that just contain the count) or a react Ref if we ever
// want to move away from the class.
class Counter {
  count = 0;
  add() {
    this.count++;
  }
  get() {
    return this.count;
  }
}

// Normally in a tree, arrays represent non-leaf nodes, but in this case
// arrays are valid leaves, and objects are the non-leaf nodes.
const isTreeLeaf = Array.isArray;

// Given a tree, it will only the first N leaves of the tree,
// while preserving the structure of the tree for those leaves.
export const getTruncatedTree = (
  tree: Tree | TreeLeaf,
  limit: number,
  count: Counter = new Counter()
) => {
  if (isTreeLeaf(tree)) {
    count.add();
    return tree;
  }

  return Object.keys(tree)
    .sort((a, b) => a.localeCompare(b))
    .reduce((newTree, key) => {
      if (count.get() >= limit) {
        return newTree;
      }

      const value = tree[key];
      newTree[key] = getTruncatedTree(value, limit, count);

      return newTree;
    }, {} as Tree);
};
